export default "__VITE_PUBLIC_ASSET__d87aa5a2__"